<template>
  <div class="el-input">
    <div style="width:10em; float: left" ><el-input :value="amount" @input="changeAmount($event)" /></div>
    <el-select :value="unit" value-key="key" :size="size" @input="change($event)" style="width:10em">
      <el-option label="G" value="G" />
      <el-option label="M" value="M" />
      <el-option label="k" value="k" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      amount: 1,
      unit: 'M'
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    changeAmount: function (val) {
      this.amount = val
      this.$emit('input', '' + this.amount + this.unit)
    },
    change: function (val) {
      this.unit = val
      this.$emit('input', '' + this.amount + this.unit)
    }
  },
  mounted () {
    let data = /([0-9]+)((G|M|k))/.exec(this.value)
    if (data) {
      this.amount = data[1]
      this.unit = data[2]
    }
    this.$emit('input', '' + this.amount + this.unit)
  },
  watch: {
    value: function (val, oldVal) {
      let data = /([0-9]+)((G|M|k))/.exec(val)
      if (data) {
        this.amount = data[1]
        this.unit = data[2]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/TrafficUnitSelect.vue